// @flow
import JQueryView, { on } from '../../common/JQueryView';
import DateRangePicker from '../../common/DateRangePicker';
import { meetingTypes } from '../../../models/StockholderMeeting';

declare var $: any;

export default class MinuteView extends JQueryView {
  constructor() {
    super('.simple_form');
    this.render();
  }

  initDateRangePicker = (container: any) => {
    const holdMethod = $(
      '#officer_approval_stockholder_meeting_hold_method',
    ).val();
    let timePicker;
    let format;
    if (holdMethod == meetingTypes.ACTUALLY || holdMethod == undefined) {
      timePicker = true;
      format = 'YYYY/MM/DD HH:mm';
    } else if (holdMethod == meetingTypes.WRITTEN) {
      timePicker = false;
      format = 'YYYY/MM/DD';
    }
    new DateRangePicker(
      container,
      {
        singleDatePicker: true,
        timePicker: timePicker,
        showDropdowns: true,
        locale: {
          format: format,
        },
      },
      {
        picker: {
          format: {
            start: format,
            template: startDate => startDate,
          },
        },
      },
    ).render();
  };

  @on({
    event: 'change',
    selector: 'input[name="officer_approval_stockholder_meeting[minute_type]"]',
  })
  onChangeMinuteType() {
    this.render();
  }

  @on({ event: 'click', selector: '.remove_fields' })
  onClickRemoveFields(event: any) {
    $(event.target)
      .prev('input[type=hidden]')
      .val('1');
    $(event.target)
      .closest('.row')
      .hide();
    event.preventDefault();
  }

  @on({ event: 'click', selector: '.add_fields' })
  onClickAddFields(event: any) {
    const time = new Date().getTime();
    const regexp = new RegExp($(event.target).data('id'), 'g');
    event.preventDefault();
    $(event.target).before(
      $(event.target)
        .data('fields')
        .replace(regexp, time),
    );
    this.render();
  }

  initAdjustReportTextArea = (): void => {
    const target = $('#report_comment_field');
    if (target.length) {
      target.css('height', 'auto');
      target.css('height', target[0].scrollHeight + 'px');
    }
  };

  initAdjustResolutionTextArea = () => {
    const target = $('#resolution_comment_field');
    if (target.length) {
      target.css('height', 'auto');
      target.css('height', target[0].scrollHeight + 'px');
    }
  };

  render() {
    const minuteType = $(
      'input[name="officer_approval_stockholder_meeting[minute_type]"]',
    )
      .filter(':checked')
      .val();

    $('.next').hide();
    $('.file_form').hide();

    if (minuteType == 'document') {
      $('.next').show();
    } else if (minuteType == 'file') {
      $('.file_form').show();
    }

    $('textarea').on('input', function() {
      this.style.height = 'auto';
      this.style.height = this.scrollHeight + 'px';
    });

    this.initAdjustReportTextArea();
    this.initAdjustResolutionTextArea();
    this.initDateRangePicker(this.$el);
  }
}
